import axios from 'axios'
import VueAxios from 'vue-axios'
import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'
import './registerServiceWorker'
import './assets/tailwind.css'

Vue.config.productionTip = false
Vue.use(VueAxios, axios)
Vue.axios.defaults.baseURL = process.env.VUE_APP_API_BASEURL
Vue.router = router
// Vue.prototype.axios = axios

Vue.use(require('@websanova/vue-auth'), {
  // refreshData: { url: 'auth/refresh', method: 'GET', enabled: true, interval: 2 },
  authRedirect: { path: '/login' },
  parseUserData (data) {
    console.log(`user data to parse: ${Object.keys(data)}`)
    return data
  },
  auth: require('@websanova/vue-auth/drivers/auth/bearer.js'),
  http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
  rolesVar: 'roles'
})

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
